import type { Dispatch, SetStateAction } from 'react';

import { Z_INDEX } from '@/config/z-index';
import HistoryRecord from '@/features/ai-chat/components/AskGXDrawer/ChatHistory/HistoryRecord/HistoryRecord';
import { Box } from '@/shared/ui/layout/Box';
import { Menu } from '@/shared/ui/overlays/Menu';
import Typography from '@/shared/ui/typography/Text';

import { useChatHistory } from './useChatHistory';

const ChatHistory = ({
  anchorEl,
  setAnchorEl
}: {
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
}) => {
  const { conversations, handleClose } = useChatHistory(setAnchorEl);

  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      open={Boolean(anchorEl)}
      sx={{
        zIndex: Z_INDEX.panel
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      onClose={handleClose}
    >
      <Box sx={{ width: '320px' }}>
        <Typography
          sx={{
            color: 'gx.textDisabled',
            fontSize: '10px',
            ml: '8px'
          }}
        >
          CHAT HISTORY
        </Typography>
        {conversations.length === 0 ? (
          <Box
            sx={{
              height: '75px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Typography>No history yet</Typography>
          </Box>
        ) : (
          conversations.map((conversation, index) => (
            <HistoryRecord
              key={conversation.conversationId}
              conversation={conversation}
              handleClose={handleClose}
              index={index}
            />
          ))
        )}
      </Box>
    </Menu>
  );
};

export default ChatHistory;
